import React, { useEffect, useRef, useState } from "react";
import "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Switch,
  Typography,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Grid,
  CircularProgress,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Box,
} from "@mui/material";
import {
  API_SERVICE_BACKEND_2,
  API_SERVICE_BACKEND,
  API_AUTH_SERVICE_BACKEND,
  APP_TIMEZONE,
} from "src/config";
import moment from "moment-timezone";
import "../style.css";
import LinkIcon from "src/components/logos/linkIcon.png";
import Linkbroken from "src/components/logos/linkBroken.png";
import { useAuth } from "src/contexts/auth/firebase-context";
import { useGetUserDetail } from "src/hooks/react-query/useAuth";
import { getServerDateTime } from "src/pages/dashboard/customers/allCustomers";
import { DifferentOwners } from "./owners"
import { Person } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ZapierIntegrationSettings from "./integrations/zapier"
import PipedriveIntegrationSettings from "./integrations/pipedrive"
import SalesforceIntegrationSettings from './integrations/salesforce'
import LogDrawer from "./LogDrawer";
import { BsCodeSlash } from "react-icons/bs";
import { TbWorld } from "react-icons/tb";
import { AiOutlineLink, AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
import { PiLinkBreakBold } from "react-icons/pi";
import { MdOutlineHistory } from "react-icons/md";
import { addDomain, verifyDomain, getDomains } from "src/api/analytics";
import { useRouter } from "src/hooks/use-router";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { addTokenAndRedirect } from "src/utils/add-token-to-url";
export const INTEGRATIONTYPE = Object.freeze({
  HUBSPOT: "hubspot",
  CALENDLY: "calendly",
  ZOHO: "zoho",
  ZAPIER: "zapier",
  SALESFORCE: "salesforce"
})

const HUBSPOTOWNERASSIGNMENTTYPE = Object.freeze({
  SEPARATE: "SEPARATE",
  DEFAULT: "DEFAULT"
})

const IntegrationSettings = (props) => {

  const {
    email,
    section9Ref,
    userCampaigns,
    loadUserCampaigns,
    userCampaignLoading
  } = props;

  const { user, setUserInfo } = useAuth();
  const { data: userDetails } = useGetUserDetail();
  const isWhiteLabelContext =
    Boolean(userDetails?.isWhiteLabel) || Boolean(userDetails?.whiteLabelUserId);
  const showHubspot = isWhiteLabelContext
    ? userDetails?.hubspotEnable === true
    : true;
  const theme = useTheme();
  const router = useRouter();
  useEffect(() => {
    if (user?.email) {
      setUserInfo(user.email);
    }
  }, [router]);
  const [isValidDomain, setIsValidDomain] = useState(false);
  const [touched, setTouched] = useState(false);
  const isValidDomainFormat = (value) => {
    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(value);
  };
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const oauthStatus = searchParams.get('message'); // ← HubSpot/Zoho callback result
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Add state for tracking code
  const [domainValue, setDomainValue] = useState("YOUR_DOMAIN");
  const organizationId = sessionStorage.getItem("organization_id") || user?.uid
  const [isZohoAuto, setIsZohoAuto] = useState(false);
  const [isHubspotAuto, setIsHubspotAuto] = useState(false);
  const [hasZohoIntegration, setHasZohoIntegration] = useState(false);
  const [hasHubSpotIntegration, setHasHubSpotIntegration] = useState(false);
  const [hasCalendlyIntegration, setHasCalendlyIntegration] = useState(false);

  const [zohoExpired, setZohoExpired] = useState(false);
  const [hubspotExpired, setHubSpotExpired] = useState(false);
  const [calendlyExpired, setCalendlyExpired] = useState(false);

  const [zohoIntegration, setZohoIntegration] = useState({});
  const [hubSpotIntegration, setHubSpotIntegration] = useState({});
  const [calendlyIntegration, setCalendlyIntegration] = useState({});
  const [zohoAutoExecution, setZohoAutoExecution] = useState();
  const [hubspotAutoExecution, setHubspotAutoExecution] = useState();
  const [hubspotUsers, setHubspotUsers] = useState()

  const [hubspotOwnerAssignment, sethubspotOwnerAssignment] = useState(HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT)
  const [selectedOwner, setSelectedOwner] = useState('')
  const [syncOnlyIfConditionsMet, setSyncOnlyIfConditionsMet] = useState(false)
  const [syncCondition, setSyncCondition] = useState('REPLIED')

  const [Baropen, setBarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const [domain, setDomain] = useState("");
  const [integrationModalOpen, setIntegrationModalOpen] = useState(false);
  const [isDomainIntegrated, setIsDomainIntegrated] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("wordpress");
  const [userDomains, setUserDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [showTrackingScript, setShowTrackingScript] = useState(false);
  const [showScript, setShowScript] = useState(false);
  const calendlyAccountInfo = calendlyIntegration?.integrations || {};
  const calendlyConnectedName = calendlyAccountInfo?.name;
  const calendlyConnectedEmail = calendlyAccountInfo?.email;
  const calendlySchedulingUrl = calendlyAccountInfo?.scheduling_url;
  const calendlyTimezone = calendlyAccountInfo?.timezone;
  const calendlyMeetingLink =
    calendlyAccountInfo?.meeting_url ||
    calendlyAccountInfo?.meeting_link ||
    calendlySchedulingUrl;
  const calendlyMeetingLinkLabel = calendlyMeetingLink
    ? calendlyMeetingLink.replace(/^https?:\/\//, "").replace(/\/$/, "")
    : "";
  const hasCalendlyDetails = Boolean(
    calendlyConnectedName ||
    calendlyConnectedEmail ||
    calendlyTimezone ||
    calendlyMeetingLink
  );

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleIntegration = () => {
    if (domain) {
      setDomainValue(domain);
      setIsDomainIntegrated(true);
      setIntegrationModalOpen(false);
      openSnackbar(`Successfully integrated tracking for ${domain}`, "success");
    }
  };

  // Function to verify if integration is working
  const verifyIntegration = () => {
    // Here you would implement logic to check if the tracking is active
    // For now, we'll just show a success message
    openSnackbar("Integration verification successful! Tracking is active.", "success");
  };

  const handleDisconnect = async (userEmail, type) => {
    // //console.log(userEmail, type, "comingData");
    try {
      /*const response = await fetch1(
        `${API_SERVICE_BACKEND_2}/removeIntegration`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userEmail: userEmail,
            type: type,
          }),
        }
      );*/
      const response = await axios.delete(
        `${API_SERVICE_BACKEND_2}/removeIntegration`,
        {
          data: {
            userEmail: userEmail,
            type: type,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // //console.log(response, "responsedel");
      if (response.status === 200 || response.status === 201 || response.status === 204 ) {
        if (type === INTEGRATIONTYPE.HUBSPOT) {
          setHasHubSpotIntegration(false);
          setHubSpotExpired(false);
          setHubSpotIntegration(null);
          openSnackbar("HubSpot disconnected successfully!", "success");
        } else if (type === INTEGRATIONTYPE.CALENDLY) {
          setHasCalendlyIntegration(false);
          setCalendlyExpired(false);
          setCalendlyIntegration(null);
          openSnackbar("Calendly disconnected successfully!", "success");
        } else if (type === INTEGRATIONTYPE.ZOHO) {
          setHasZohoIntegration(false);
          setZohoExpired(false);
          setZohoIntegration(null);
          openSnackbar("Zoho disconnected successfully!", "success");
        }
      } else {
        const errorData = response.data;
        console.error(`Error: ${errorData.error}`);
      }
    } catch (error) {
      console.error("Internal Server Error:", error);
    }
  };

  const updateIntegrationAutoSyncFlag = async (email, type, isAuto) => {
    try {
      /*await fetch1(`${API_SERVICE_BACKEND_2}/updateIntegration`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          isAuto: isAuto,
          userEmail: email,
          type: type,
        }),
      }); */
      await axios.post(`${API_SERVICE_BACKEND_2}/updateIntegration`,
        {
          isAuto: isAuto,
          userEmail: email,
          type: type,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error updating isAuto:", error);
    }
  };
  const trackingCode = `<!-- Analytics Tracking Code -->
<script 
  async 
  src="https://cdn.jsdelivr.net/gh/leadinglydevelopment/pixel-tracking@latest/pixel.js" 
 data-site-id="${domain.trim()}" data-user-id="${organizationId}"
></script>`;

  // Function to copy the tracking code to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(trackingCode);
    openSnackbar("Tracking code copied to clipboard", "success");
  };

  const initiateHubSpotOAuth = () => {
    // ✅ Form submission or window.location.href required for 302 redirect
    const returnPath = `${window.location.origin}/dashboard/account?tab=integrations`;
    const params = new URLSearchParams({ returnPath });
    //window.location.href = `${API_AUTH_SERVICE_BACKEND}/oauth/hubspot?${params.toString()}`;
    const url = `${API_AUTH_SERVICE_BACKEND}/oauth/hubspot?${params.toString()}`;
    addTokenAndRedirect(url)
  };

  const initiateZohoOAuth = () => {
    // Use auth server (same flow as HubSpot) — no direct Zoho URL
    const returnPath = `${window.location.origin}/dashboard/account?tab=integrations`;
    const params = new URLSearchParams({
      returnPath,
      location: "com", // Zoho data center: in, com, eu, au, jp, uk, ca, us
    });
    //window.location.href = `${API_AUTH_SERVICE_BACKEND}/oauth/zoho?${params.toString()}`;
    const url = `${API_AUTH_SERVICE_BACKEND}/oauth/zoho?${params.toString()}`;
    addTokenAndRedirect(url)
  };

  const initiateCalendlyOAuth = () => {
    const returnPath = `${window.location.origin}/dashboard/account?tab=integrations`;
    const params = new URLSearchParams({ returnPath });
    const url = `${API_AUTH_SERVICE_BACKEND}/oauth/calendly?${params.toString()}`;
    addTokenAndRedirect(url)
  };

  const changeOwnerAssignmentStatus = (value) => {
    sethubspotOwnerAssignment(value)
    if (value === HUBSPOTOWNERASSIGNMENTTYPE.SEPARATE) {
      loadUserCampaigns()
    }
  }

  const addOwner = async (e) => {
    e.preventDefault();
    //console.log('selected owner', selectedOwner)
    try {
      /*await fetch1(`${API_SERVICE_BACKEND_2}/hubspot-owners-save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userEmail: user.email,
          type: INTEGRATIONTYPE.HUBSPOT,
          compain_id: undefined,
          owner_id: selectedOwner,
          hubspotOwnerAssignment: hubspotOwnerAssignment
        }),
      }); */
      await axios.post(`${API_SERVICE_BACKEND_2}/hubspot-owners-save`, 
        {
          userEmail: user.email,
          type: INTEGRATIONTYPE.HUBSPOT,
          compain_id: undefined,
          owner_id: selectedOwner,
          hubspotOwnerAssignment: hubspotOwnerAssignment
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      openSnackbar("Default owner assigned for all agents.", "success");
    } catch (error) {
      console.error("Error updating isAuto:", error);
    }
  }

  const saveSyncCondition = async (syncOnlyIfConditionsMetValue=false, syncConditionValue='REPLIED') => {
    try {
      
      /*await fetch1(`${API_SERVICE_BACKEND_2}/hubspot-sync-condition-save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userEmail: user.email,
          type: INTEGRATIONTYPE.HUBSPOT,
          syncOnlyIfConditionsMet: syncOnlyIfConditionsMetValue,
          syncCondition: syncConditionValue
        }),
      });*/
      await axios.post(`${API_SERVICE_BACKEND_2}/hubspot-sync-condition-save`, 
        {
          userEmail: user.email,
          type: INTEGRATIONTYPE.HUBSPOT,
          syncOnlyIfConditionsMet: syncOnlyIfConditionsMetValue,
          syncCondition: syncConditionValue
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      openSnackbar("Sync condition settings saved successfully.", "success");
    } catch (error) {
      console.error("Error saving sync condition:", error);
      openSnackbar("Error saving sync condition settings.");
    }
  }

  const openSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setBarOpen(true);
  };

  useEffect(() => {
    if (from === 'integrateClick') {
      setIntegrationModalOpen(true);
      setDomain("");
      setShowScript(false);
      setIsValidDomain(false);
      setTouched(false);
    }
  }, [from]);

  // ── OAuth callback toast ────────────────────────────────────────────────────
  // Backend redirects back with ?oauth=success or ?oauth=fail after HubSpot/Zoho
  // Zoho returns ?oauth=Account+connected+successfully on success
  const decodedOauthStatus = decodeURIComponent((oauthStatus || '').replace(/\+/g, ' ')).trim();
  const isOAuthSuccess =
    decodedOauthStatus === 'success' ||
    decodedOauthStatus === 'Account connected successfully';

  const handledOauthStatusRef = useRef(null);

  useEffect(() => {
    if (!oauthStatus || handledOauthStatusRef.current === oauthStatus) return;
    handledOauthStatusRef.current = oauthStatus;

    if (isOAuthSuccess) {
      if (user?.email) {
        setUserInfo(user.email);
      }
      openSnackbar('Integration connected successfully! 🎉', 'success');
    } else {
      openSnackbar('Integration failed. Please try again.', 'error');
    }

    const cleanParams = new URLSearchParams(window.location.search);
    cleanParams.delete('oauth');
    cleanParams.delete('message');
    cleanParams.delete('status');
    const newUrl = window.location.pathname + (cleanParams.toString() ? `?${cleanParams.toString()}` : '');
    router.replace(newUrl);
  }, [oauthStatus, isOAuthSuccess, setUserInfo, user?.email, router]);


  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setBarOpen(false);
  };
  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const domains = await getDomains(organizationId);
        setUserDomains(domains.data);
      } catch (error) {
        console.error("Error fetching domains:", error);
        openSnackbar("Failed to fetch domains", "error");
      }
    };

    if (organizationId) {
      fetchDomains();
    }
  }, [organizationId]);

  // Fetch fresh integration data to ensure we have the latest sync condition settings
  useEffect(() => {
    const fetchFreshIntegrationData = async () => {
      if (email && hasHubSpotIntegration) {
        try {
          //const response = await fetch1(`${API_SERVICE_BACKEND}/getUserIntegrations/${encodeURIComponent(email)}`);
          const response = await axios.get(`${API_SERVICE_BACKEND}/getUserIntegrations/${encodeURIComponent(email)}`);
          const integrationsData = response?.data;
          const hubspotIntegration = integrationsData?.find(
            (integration) => integration.type === "hubspot"
          );
          
          if (hubspotIntegration) {
            //console.log('Fresh HubSpot integration data fetched:', hubspotIntegration);
            setHubSpotIntegration(hubspotIntegration);
            
            // Update sync condition settings from fresh data
            if (hubspotIntegration.syncOnlyIfConditionsMet !== undefined && hubspotIntegration.syncOnlyIfConditionsMet !== null) {
              if (!hubspotIntegration.isAuto) {
                setSyncOnlyIfConditionsMet(hubspotIntegration.syncOnlyIfConditionsMet);
              }
            }
            if (hubspotIntegration.syncCondition) {
              setSyncCondition(hubspotIntegration.syncCondition);
            }
          }
        } catch (error) {
          console.error('Error fetching fresh integration data:', error);
        }
      }
    };
    
    fetchFreshIntegrationData();
  }, [email, hasHubSpotIntegration]);

  useEffect(() => {
    const tokenZoho = user?.integrations?.zoho?.access_token;
    const zohoLastAutoExecution = user?.integrations?.zoho?.lastAutoExecution;
    const formattedZohoLastAutoExecution = moment(zohoLastAutoExecution).format(
      "MMMM Do YYYY, h:mm:ss a"
    );
    if (tokenZoho) {
      setHasZohoIntegration(true);
      setZohoIntegration(user?.integrations?.zoho);
      setIsZohoAuto(user?.integrations?.zoho?.isAuto);
      setZohoAutoExecution(formattedZohoLastAutoExecution);
    } else {
      setHasZohoIntegration(false);
    }

    const tokenHubspot = user?.integrations?.hubspot?.access_token;
    const hubspotLastAutoExecution =
      user?.integrations?.hubspot?.lastAutoExecution;
    const formattedHubspotLastAutoExecution = moment(
      hubspotLastAutoExecution
    ).format("MMMM Do YYYY, h:mm:ss a");
    if (tokenHubspot) {
      setHasHubSpotIntegration(true);
      setHubSpotIntegration(user?.integrations?.hubspot);
      setIsHubspotAuto(user?.integrations?.hubspot?.isAuto);
      setHubspotAutoExecution(formattedHubspotLastAutoExecution);
    } else {
      setHasHubSpotIntegration(false);
    }

    const tokenCalendly =
      user?.integrations?.calendly?.access_token ||
      user?.integrations?.calendly?.refresh_token;
    if (tokenCalendly) {
      setHasCalendlyIntegration(true);
      setCalendlyIntegration(user?.integrations?.calendly);
    } else {
      setHasCalendlyIntegration(false);
    }

    //console.log({ user });
  }, [user]);

  useEffect(() => {
    (async () => {
      const { dateTime } = await getServerDateTime();
      const now = moment.tz(dateTime, APP_TIMEZONE);

      if (
        moment.tz(hubSpotIntegration?.expires_at, APP_TIMEZONE).unix() <
        now.unix()
      ) {
        setHubSpotExpired(true);
      } else {
        setHubSpotExpired(false);
      }

      if (hubSpotIntegration?.hubspotOwnerAssignment) {
        sethubspotOwnerAssignment(hubSpotIntegration?.hubspotOwnerAssignment)
      }

      if (hubSpotIntegration?.defaultHubspotContactsOwner) {
        setSelectedOwner(hubSpotIntegration?.defaultHubspotContactsOwner)
      }

      if (hubSpotIntegration?.isAuto && hubSpotIntegration?.syncOnlyIfConditionsMet) {
        setSyncOnlyIfConditionsMet(false);
      } else {
        if ('syncOnlyIfConditionsMet' in hubSpotIntegration) {
          const syncConditionValue = hubSpotIntegration.syncOnlyIfConditionsMet;
          setSyncOnlyIfConditionsMet(!!syncConditionValue);
        }

        if (hubSpotIntegration?.syncCondition) {
          setSyncCondition(hubSpotIntegration?.syncCondition)
        }
      }

      if (
        moment.tz(zohoIntegration?.expires_at, APP_TIMEZONE).unix() < now.unix()
      ) {
        setZohoExpired(true);
      } else {
        setZohoExpired(false);
      }

      if (calendlyIntegration?.expires_at) {
        if (
          moment.tz(calendlyIntegration?.expires_at, APP_TIMEZONE).unix() < now.unix()
        ) {
          setCalendlyExpired(true);
        } else {
          setCalendlyExpired(false);
        }
      } else {
        setCalendlyExpired(false);
      }
    })();
  }, [hubSpotIntegration, zohoIntegration, calendlyIntegration]);

  useEffect(() => {

    const getOwnersList = async () => {
      try {
        /*const res = await fetch1(`${API_SERVICE_BACKEND_2}/hubspot-contacts?email=${encodeURIComponent(email)}&refresh_token=${user?.integrations?.hubspot?.refresh_token}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then(response => response.json());*/
        const res = await axios.get(`${API_SERVICE_BACKEND_2}/hubspot-contacts?email=${encodeURIComponent(email)}&refresh_token=${user?.integrations?.hubspot?.refresh_token}`, {
          headers: {
            "Content-Type": "application/json",
          },
        }).then(response => response.data);

        setHubspotUsers(res.results)
      } catch (error) {
        console.error("Error contacts list:", error);
      }
    }

    const defContacts = async () => {
      if (hubSpotIntegration) {
        getOwnersList()
      }
    }
    defContacts()
  }, [hubSpotIntegration])
  const verifyBtnRef = useRef(null);
  useEffect(() => {
    if (verifyBtnRef.current) {
      verifyBtnRef.current.textContent = 'Verify Integration';
      verifyBtnRef.current.disabled = false;
      verifyBtnRef.current.style.backgroundColor = '';
      verifyBtnRef.current.style.color = '';
      verifyBtnRef.current.style.borderColor = '';
      verifyBtnRef.current.innerHTML = 'Verify Integration';
    }
  }, [selectedDomain]);
  return (


    <Stack
      gap={2}
      ref={section9Ref}
      id="section9"
      justifyContent={"space-between"}
      sx={{
        flexWrap: "wrap",
        width: "100%",
        transition: "all 0.3s ease-in-out",
      }}

    >



      {/* Pipedrive Section */}
      <Stack
        direction={"row"}

        justifyContent={"space-between"}
        sx={{ flexWrap: "wrap", width: "100%" }}
      >

        {/* Pipedrive Settings Section */}

        <PipedriveIntegrationSettings updateIntegrationAutoSyncFlag={updateIntegrationAutoSyncFlag} openSnackbar={openSnackbar} />

        {/* Zapier Settings Section */}
        <ZapierIntegrationSettings />
      </Stack>
      <Stack
        direction={"row"}

        justifyContent={"space-between"}
        sx={{ flexWrap: "wrap", width: "100%" }}
      >
        {/* <SalesforceIntegrationSettings /> */}

        {/* Zoho Settings Section */}
        <Card sx={{
          marginTop: "10px",
           width: "100%",
          // width: { xs: "100%", md: "49%" },
          border: "1px solid #EAECF0",
          borderRadius: "8px"

        }}
          className="glass-wrapper"
        >
          <CardContent style={{ padding: "24px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  style={{ marginRight: "10px" }}
                  width="28"
                  height="28"
                  src="https://uploads-ssl.webflow.com/594d8d64dc2b583adddea915/5a7fd806c7942700013399da_zoho.png"
                  alt="external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo"
                />
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Zoho
                </Typography>
              </div>

              {
                hasZohoIntegration ? (
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      color: zohoExpired ? "red" : "green",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={initiateZohoOAuth}
                      sx={{


                        marginRight: "5px",
                        marginLeft: "5px",
                        padding: "5px 10px",
                        fontSize: "0.8em"
                      }}

                    >
                      <>
                        {/* <img
                              src={LinkIcon}
                              style={{ marginRight: "8px" }}
                            /> */}
                        <AiOutlineLink
                          style={{
                            marginRight: "4px",
                            height: "23px",
                            fontSize: "38px",

                          }}
                        />
                      </>
                      Reconnect
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() =>
                        handleDisconnect(
                          user?.dbRef?.email,
                          INTEGRATIONTYPE.ZOHO
                        )
                      }
                      sx={{


                        marginRight: "10px",
                        marginLeft: "5px",
                        padding: "5px 10px",
                        fontSize: "0.8em"
                      }}
                    // className="glass-button-secondary-25"
                    >
                      <>
                        {/* <img
                              src={Linkbroken}
                              style={{ marginRight: "8px" }}
                            /> */}
                        <PiLinkBreakBold

                          style={{
                            marginRight: "8px",

                            fontSize: "26px",
                            color: theme.palette.text.primary,
                          }}
                        />
                      </>
                      Disconnect
                    </Button>
                  </div>
                ) : <Button
                  variant="contained"
                  color="primary"
                  onClick={initiateZohoOAuth}
                  size="small"
                  sx={{


                    marginLeft: "5px",
                    width: "max-content",
                    padding: "5px 10px",
                    fontSize: "0.8em"
                  }}
                // className="glass-button-secondary-25"
                >
                  {/* <img
                        src={LinkIcon}
                        style={{ marginRight: "8px" }}
                      /> */}
                  <>
                    <AiOutlineLink
                      style={{
                        marginRight: "4px",
                        height: "23px",
                        fontSize: "38px",

                      }}
                    />


                  </>
                  Connect
                </Button>
              }
            </div>

            <Grid item xs={4} paddingTop={"20px"}>
              <Typography fontSize={"16px"} paddingTop={"20px"} color={theme => theme.palette.text.primary}>ZoHo</Typography>

              <Typography fontSize={"16px"} paddingTop={"5px"} color={theme => theme.palette.text.secondary}>
                Integrate your Zoho Automations to
                simplify and automate your daily tasks effortlessly
              </Typography>

            </Grid>
            <div style={{ display: "flex", margin: "16px 0px" }} >
              {
                hasZohoIntegration ? (
                  <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item md={4}>
                      <Typography fontSize={"14px"} fontWeight={400}>{'Auto Transfer Leads'}</Typography>
                    </Grid>

                    {
                      hasZohoIntegration &&
                        isZohoAuto &&
                        zohoAutoExecution !== "Invalid date" ? (
                        <Grid item md={4} sx={{ textAlign: "center" }}>
                          <Typography
                            style={{
                              color: theme.palette.text.primary,
                              fontWeight: "bold",
                            }}
                            fontSize={12}
                          >
                            Last Auto Sync
                          </Typography>
                          <Typography fontSize={12} style={{ color: theme.palette.text.secondary }}>
                            {zohoAutoExecution}
                          </Typography>
                        </Grid>
                      ) : null
                    }

                    <Grid item md={4} sx={{ textAlign: "right" }}>
                      <Switch
                        checked={isZohoAuto}
                        onChange={async ({
                          target: { checked },
                        }) => {
                          setIsZohoAuto(checked);
                          try {
                            await updateIntegrationAutoSyncFlag(
                              user.email,
                              INTEGRATIONTYPE.ZOHO,
                              checked
                            );
                          } catch (ex) {
                            //console.log({ ex });
                          }
                        }}
                        value={INTEGRATIONTYPE.ZOHO}
                      />
                    </Grid>
                  </Grid>
                ) : null
              }

            </div>
          </CardContent>
        </Card>
      </Stack>

      {/* HubSpot Settings Section */}
      {showHubspot && (
      <Card
        style={{
          marginTop: '1rem',
          
          borderRadius: "8px",
          //height: "70vh",
          height: hubspotOwnerAssignment === HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT
            ? "auto"
            : "70vh",
          width: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
        className="glass-wrapper">
        <CardContent
          style={{
            padding: "24px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box sx={{ flexShrink: 0 }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  style={{ marginRight: "10px" }}
                  width="28"
                  height="28"
                  src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo.png"
                  alt="external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo"
                />
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Hubspot
                </Typography>
              </div>

              {hasHubSpotIntegration ? (
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    color: hubspotExpired ? "red" : "green",
                  }}
                >

                  <Button
                    variant="contained"
                    onClick={initiateHubSpotOAuth}
                    sx={{
                      marginRight: "5px",
                      marginLeft: "5px",
                      padding: "5px 10px",
                      fontSize: "0.8em"
                    }}
                  >
                    <>
                      <AiOutlineLink
                        style={{
                          marginRight: "4px",
                          height: "23px",
                          fontSize: "38px",
                        }}
                      />
                    </>
                    Reconnect
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    onClick={() =>
                      handleDisconnect(
                        user?.dbRef?.email,
                        INTEGRATIONTYPE.HUBSPOT
                      )
                    }
                    sx={{

                      // border: "1px solid #ECE9F5",
                      marginRight: "10px",
                      marginLeft: "5px",
                      padding: "5px 10px",
                      fontSize: "0.8em"
                    }}

                  >
                    <>

                      <PiLinkBreakBold

                        style={{
                          marginRight: "8px",

                          fontSize: "26px",

                        }}
                      />

                    </>
                    Disconnect
                  </Button>
                </div>
              ) : (
              <>
              <Button
                variant="contained"
                onClick={initiateHubSpotOAuth}
                size="small"
                sx={{
                  marginLeft: "5px",
                  width: "max-content",
                  padding: "5px 10px",
                  fontSize: "0.8em"
                }}
              >
                <>
                  <AiOutlineLink
                    style={{
                      marginRight: "4px",
                      height: "23px",
                      fontSize: "38px",
                    }}
                  />
                </>
                Connect
              </Button>
              </>
              )}
            </div>
            <Grid item xs={4} paddingTop={"10x"}>
              <Typography fontSize={"16px"} paddingTop={"20px"} color={theme => theme.palette.text.primary}>HubSpot</Typography>

              <Typography fontSize={"16px"} paddingTop={"5px"} color={theme => theme.palette.text.secondary}>
                Integrate your Hubspot Automations to
                simplify and automate your daily tasks effortlessly
              </Typography>

            </Grid>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              marginTop: "8px",
              paddingRight: "8px",
            }}
          >
            {
              hasHubSpotIntegration &&
              <>

                <div style={{ display: "flex", margin: "16px 0px" }}>
                  {
                    hasHubSpotIntegration ? (
                      <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item md={4}>
                          <Typography fontSize={"14px"} fontWeight={400}>{'Auto Transfer Leads'}</Typography>
                        </Grid>

                        {
                          hasHubSpotIntegration &&
                            isHubspotAuto &&
                            hubspotAutoExecution !== "Invalid date" ? (
                            <Grid item md={4} sx={{ textAlign: "center" }}>
                              <Typography
                                style={{
                                  color: theme.palette.text.primary,
                                  fontWeight: "bold",
                                }}
                                fontSize={12}
                              >
                                Last Auto Sync
                              </Typography>
                              <Typography fontSize={12} style={{ color: theme.palette.text.secondary }}>
                                {hubspotAutoExecution}
                              </Typography>
                            </Grid>
                          ) : null
                        }


                        <Grid item md={4} sx={{ textAlign: "right" }}>
                          <Switch
                            checked={isHubspotAuto}
                            onChange={async ({
                              target: { checked },
                            }) => {
                              if (checked && syncOnlyIfConditionsMet) {
                                setSyncOnlyIfConditionsMet(false);
                                // setSyncCondition('');
                                try {
                                  await saveSyncCondition(false, '');
                                } catch (ex) {
                                  //console.log({ ex });
                                }
                              }
                              setIsHubspotAuto(checked);
                              try {
                                await updateIntegrationAutoSyncFlag(
                                  user.email,
                                  INTEGRATIONTYPE.HUBSPOT,
                                  checked
                                );
                              } catch (ex) {
                                //console.log({ ex });
                              }
                            }}
                            value={INTEGRATIONTYPE.HUBSPOT}
                          />
                        </Grid>
                      </Grid>
                    ) : null
                  }

                </div>
                {/* Sync Only If Lead Meets Conditions */}
                <div style={{ display: "flex", margin: "16px 0px" }}>
                  {
                    hasHubSpotIntegration ? (
                      <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item md={4}>
                          <Typography fontSize={"14px"} fontWeight={400}>{'Sync only if lead meets conditions'}</Typography>
                        </Grid>
                        <Grid item md={4} sx={{ textAlign: "right" }}>
                          <Switch
                            checked={syncOnlyIfConditionsMet}
                            onChange={async ({
                              target: { checked },
                            }) => {
                              // If sync condition is turned ON and auto sync is ON, turn OFF auto sync first
                              if (checked && isHubspotAuto) {
                                setIsHubspotAuto(false);
                                try {
                                  await updateIntegrationAutoSyncFlag(
                                    user.email,
                                    INTEGRATIONTYPE.HUBSPOT,
                                    false
                                  );
                                } catch (ex) {
                                  //console.log({ ex });
                                }
                              }
                              setSyncOnlyIfConditionsMet(checked);
                              try {
                                await saveSyncCondition(checked, checked ? syncCondition : '');
                              } catch (ex) {
                                //console.log({ ex });
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    ) : null
                  }
                </div>
                {syncOnlyIfConditionsMet && hasHubSpotIntegration && (
                  <div style={{ display: "flex", margin: "16px 0px", alignItems: "center" }}>
                    <Grid container spacing={2} alignItems={"center"}>
                      <Grid item md={4}>
                        <Typography fontSize={"14px"} fontWeight={400}>Select syncing Condition:</Typography>
                      </Grid>
                      <Grid item md={6}>
                        <FormControl sx={{ maxWidth: "300px", width: "100%" }}>
                          <InputLabel id="select-condition-label">Syncing Condition</InputLabel>
                          <Select
                            labelId="select-condition-label"
                            id="select-condition"
                            value={syncCondition}
                            label="Condition"
                            className="glass-dropdown"
                            onChange={(e) => {
                              const newCondition = e.target.value;
                              setSyncCondition(newCondition);
                              saveSyncCondition(syncOnlyIfConditionsMet, newCondition);
                            }}
                          >
                            <MenuItem value="REPLIED">Replied</MenuItem>
                            <MenuItem value="CLICKED">Clicked</MenuItem>
                            <MenuItem value="OPENED">Opened</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                )}
                <Card
                  style={{
                    height: "calc(100% - 80px)",
                    boxShadow: "none",
                    background: "transparent",

                  }}

                >
                  <CardContent sx={{ p: 0 }}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="ownertype-group-label"
                        name="ownertype-group"
                        defaultValue={hubspotOwnerAssignment}
                      >
                        <FormControlLabel value={HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT} control={<Radio onChange={(e) => changeOwnerAssignmentStatus(e.target.value)} />} label="Use Single Default Owner for Campaigns" checked={HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT == hubspotOwnerAssignment} />
                        <FormControlLabel value={HUBSPOTOWNERASSIGNMENTTYPE.SEPARATE} control={<Radio onChange={(e) => changeOwnerAssignmentStatus(e.target.value)} />} label="Use Different Owner for Different Campaigns" checked={HUBSPOTOWNERASSIGNMENTTYPE.SEPARATE == hubspotOwnerAssignment} />
                      </RadioGroup>
                    </FormControl>
                  </CardContent>

                  <Divider />

                  <CardContent sx={{
                    pt: 1,
                    // height: "calc(100% - 80px)",
                    height:
                      hubspotOwnerAssignment === HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT
                        ? "auto"
                        : "calc(100% - 80px)",
                    overflow: "auto"
                  }}>
                    {
                      hubspotOwnerAssignment === HUBSPOTOWNERASSIGNMENTTYPE.DEFAULT &&
                      <form onSubmit={addOwner}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6} >
                            <FormControl sx={{ maxWidth: "300px", width: "100%" }}>
                              <InputLabel id="select-owner-label">Select Owner</InputLabel>
                              <Select
                                labelId="select-owner-label"
                                id="select-owner"
                                value={selectedOwner}
                                label="Select Owner"
                                className="glass-dropdown"
                                onChange={(e) => {
                                  setSelectedOwner(e.target.value)
                                }}
                              >
                                {
                                  hubspotUsers?.map((hubspotUser, index) => {
                                    return <MenuItem key={index} value={hubspotUser.id}>{hubspotUser.firstName}</MenuItem>
                                  })
                                }
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Button
                          type="submit"
                          variant="contained"
                          size="small"
                          color="primary"
                          sx={{
                            mt: 1,
                            ml: "auto",
                            borderRadius: "8px",
                            backgroundColor: theme.palette.primary.main,
                            color: "white",
                            "&:hover": {
                              backgroundColor: "theme.palette.primary.main",
                            },
                          }}
                          startIcon={<Person />}
                        >
                          Save Changes
                        </Button>
                      </form>
                    }

                    {
                      hubspotOwnerAssignment === HUBSPOTOWNERASSIGNMENTTYPE.SEPARATE && (
                        userCampaignLoading === false ? <DifferentOwners userCampaigns={userCampaigns} hubspotUsers={hubspotUsers} props={{
                          userEmail: user.email,
                          type: INTEGRATIONTYPE.HUBSPOT,
                          hubspotOwnerAssignment: hubspotOwnerAssignment
                        }}
                          openSnackbar={openSnackbar}
                        /> : <div style={{ textAlign: "center" }}><CircularProgress /></div>
                      )
                    }
                  </CardContent>
                </Card>
              </>
            }
          </Box>
        </CardContent>
      </Card>
      )}

      <Card
        style={{
          marginTop: '1rem',
          borderRadius: "8px",
          width: "100%",
        }}
        className="glass-wrapper">
        <CardContent
          style={{
            padding: "24px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <img
                style={{ marginRight: "10px" }}
                width="28"
                height="28"
                src="https://calendly.com/favicon.ico"
                alt="Calendly"
              />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: theme.palette.text.primary,
                }}
              >
                Calendly
              </Typography>
            </div>

            {hasCalendlyIntegration ? (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  color: calendlyExpired ? "red" : "green",
                }}
              >
                <Button
                  variant="contained"
                  onClick={initiateCalendlyOAuth}
                  sx={{
                    marginRight: "5px",
                    marginLeft: "5px",
                    padding: "5px 10px",
                    fontSize: "0.8em"
                  }}
                >
                  <>
                    <AiOutlineLink
                      style={{
                        marginRight: "4px",
                        height: "23px",
                        fontSize: "38px",
                      }}
                    />
                  </>
                  Reconnect
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  onClick={() =>
                    handleDisconnect(
                      user?.dbRef?.email,
                      INTEGRATIONTYPE.CALENDLY
                    )
                  }
                  sx={{
                    marginRight: "10px",
                    marginLeft: "5px",
                    padding: "5px 10px",
                    fontSize: "0.8em"
                  }}
                >
                  <>
                    <PiLinkBreakBold
                      style={{
                        marginRight: "8px",
                        fontSize: "26px",
                      }}
                    />
                  </>
                  Disconnect
                </Button>
              </div>
            ) : (
              <Button
                variant="contained"
                onClick={initiateCalendlyOAuth}
                size="small"
                sx={{
                  marginLeft: "5px",
                  width: "max-content",
                  padding: "5px 10px",
                  fontSize: "0.8em"
                }}
              >
                <>
                  <AiOutlineLink
                    style={{
                      marginRight: "4px",
                      height: "23px",
                      fontSize: "38px",
                    }}
                  />
                </>
                Connect
              </Button>
            )}
          </div>

          <Box sx={{ pt: 3 }}>
            <Typography fontSize={"16px"} color={theme => theme.palette.text.primary}>
              Calendly
            </Typography>

            <Typography
              fontSize={"14px"}
              paddingTop={"6px"}
              color={theme => theme.palette.text.secondary}
              sx={{ maxWidth: "820px", lineHeight: 1.6 }}
            >
              Connect Calendly so your team can quickly verify the linked account, active timezone,
              and the public booking page being shared with prospects.
            </Typography>

            {hasCalendlyIntegration ? (
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  borderRadius: "12px",
                  border: `1px solid ${theme.palette.divider}`,
                  backgroundColor: theme.palette.action.hover,
                }}
              >
                <Stack spacing={2}>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                  >
                    <Chip
                      size="small"
                      color="success"
                      icon={<AiOutlineCheck  
                        style={{
                          color: "#fff",
                         fontSize: "16px",
                         fontWeight:"500",
                                }}/>}
                      label="Connected"
                    />
                    <Typography fontSize={"13px"} color={theme => theme.palette.text.secondary}>
                      {hasCalendlyDetails
                        ? "Account details and booking link are available below."
                        : "Calendly is connected. Reconnect once to refresh account details here."}
                    </Typography>
                  </Stack>

                  {hasCalendlyDetails ? (
                    <Box sx={{ display: "grid", rowGap: 1.5 }}>
                      {calendlyConnectedName || calendlyConnectedEmail ? (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "170px minmax(0, 1fr)" },
                            columnGap: 2,
                            rowGap: 0.5,
                          }}
                        >
                          <Typography
                            fontSize={"13px"}
                            fontWeight={600}
                            color={theme => theme.palette.text.secondary}
                          >
                            Connected account
                          </Typography>
                          <Typography
                            fontSize={"14px"}
                            color={theme => theme.palette.text.primary}
                            sx={{ wordBreak: "break-word" }}
                          >
                            {calendlyConnectedName || calendlyConnectedEmail}
                          </Typography>
                        </Box>
                      ) : null}

                      {calendlyConnectedEmail ? (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "170px minmax(0, 1fr)" },
                            columnGap: 2,
                            rowGap: 0.5,
                          }}
                        >
                          <Typography
                            fontSize={"13px"}
                            fontWeight={600}
                            color={theme => theme.palette.text.secondary}
                          >
                            Email
                          </Typography>
                          <Typography
                            fontSize={"14px"}
                            color={theme => theme.palette.text.primary}
                            sx={{ wordBreak: "break-word" }}
                          >
                            {calendlyConnectedEmail}
                          </Typography>
                        </Box>
                      ) : null}

                      {calendlyTimezone ? (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "170px minmax(0, 1fr)" },
                            columnGap: 2,
                            rowGap: 0.5,
                          }}
                        >
                          <Typography
                            fontSize={"13px"}
                            fontWeight={600}
                            color={theme => theme.palette.text.secondary}
                          >
                            Timezone
                          </Typography>
                          <Typography
                            fontSize={"14px"}
                            color={theme => theme.palette.text.primary}
                          >
                            {calendlyTimezone}
                          </Typography>
                        </Box>
                      ) : null}

                      {calendlyMeetingLink ? (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "170px minmax(0, 1fr)" },
                            columnGap: 2,
                            rowGap: 0.5,
                          }}
                        >
                          <Typography
                            fontSize={"13px"}
                            fontWeight={600}
                            color={theme => theme.palette.text.secondary}
                          >
                            Meeting link
                          </Typography>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography
                              component="a"
                              href={calendlyMeetingLink}
                              target="_blank"
                              rel="noreferrer"
                              fontSize={"14px"}
                              sx={{
                                display: "inline-block",
                                color: theme.palette.primary.main,
                                textDecoration: "none",
                                wordBreak: "break-all",
                              }}
                            >
                              {calendlyMeetingLinkLabel}
                            </Typography>
                            <Typography
                              fontSize={"12px"}
                              paddingTop={"4px"}
                              color={theme => theme.palette.text.secondary}
                            >
                              Share this link so invitees can book a meeting directly.
                            </Typography>
                          </Box>
                        </Box>
                      ) : null}
                    </Box>
                  ) : null}
                </Stack>
              </Box>
            ) : (
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  borderRadius: "12px",
                  border: `1px dashed ${theme.palette.divider}`,
                  backgroundColor: theme.palette.action.hover,
                }}
              >
                <Typography fontSize={"13px"} color={theme => theme.palette.text.secondary}>
                  Once connected, this section will show the account owner, email, timezone,
                  and meeting booking link so it is easy to confirm the right Calendly page is in use.
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>



      <Snackbar
        open={Baropen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} style={{ color: "white" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <LogDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      {/* Website Tracking Integration Section */}
      <Card style={{ marginTop: '1rem', borderRadius: "8px", width: "100%" }} className="glass-wrapper">
        <CardContent style={{ padding: "24px" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <TbWorld
                style={{
                  marginRight: "10px",
                  fontSize: "28px",
                  color: theme.palette.text.primary,
                }}
              />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: theme.palette.text.primary,
                }}
              >
                Website Tracking
              </Typography>
            </div>
          </div>

          <Divider />
          <div style={{ margin: "16px 0px" }}>
            <Typography fontSize="14px" sx={{ mb: 2 }}>
              Track and capture visitor activity on your website by integrating our tracking script.
            </Typography>

            {userDomains && userDomains.length > 0 ? (
              <div style={{ marginBottom: '16px' }}>
                <Typography fontSize="14px" sx={{ mb: 1 }}>
                  Your domains:
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {userDomains.map((domainObj, index) => (
                    <Chip
                      key={index}
                      label={domainObj.domain}
                      clickable
                      onClick={() => {
                        if (selectedDomain === domainObj.domain) {
                          // Unselect if clicking the same domain again
                          setDomain('');
                          setSelectedDomain('');
                        } else {
                          // Select the new domain
                          setDomain(domainObj.domain);
                          setSelectedDomain(domainObj.domain);
                        }
                      }}
                      color={selectedDomain === domainObj.domain ? "primary" : "default"}
                      sx={{ mb: 1 }}
                    />
                  ))}
                </Stack>
              </div>
            ) : (
              <Typography fontSize="14px" sx={{ mb: 2, fontStyle: 'italic', color: 'text.secondary' }}>
                No domains integrated yet.
              </Typography>
            )}

            <div style={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                onClick={() => {
                  setIntegrationModalOpen(true)
                  setDomain("")
                  setShowScript(false)
                  setIsValidDomain(false)
                  setTouched(false)
                }}
                startIcon={<AiOutlinePlus />}
              >
                Integrate Website
              </Button>
              {selectedDomain && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setDomain(selectedDomain);
                    setShowScript(true);
                    setIntegrationModalOpen(true);
                    setIsValidDomain(true);
                    setTouched(false);
                  }}
                  startIcon={<BsCodeSlash />}
                  sx={{ ml: 2 }}
                  className="glass-button-secondary-50"
                >
                  View Script
                </Button>
              )}

              {selectedDomain && (
                <Button
                  variant="outlined"
                  onClick={async () => {
                    if (domain) {
                      const verifyBtn = verifyBtnRef.current;
                      verifyBtn.textContent = "Verifying...";
                      verifyBtn.disabled = true;

                      try {
                        const response = await verifyDomain(organizationId, domain);
                        if (response.status === "ok") {
                          verifyBtn.innerHTML = `<span class="MuiButton-startIcon MuiButton-iconSizeMedium css-1d6wzja-MuiButton-startIcon">
                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z">
                            </path>
                          </svg>
                          </span>Verified`;
                          verifyBtn.style.backgroundColor = '#e6f7e6';
                          verifyBtn.style.color = '#2e7d32';
                          verifyBtn.style.borderColor = '#2e7d32';

                          setIsDomainIntegrated(true);
                          toast.success('Website verified successfully!');
                        } else {
                          throw new Error('Backend verification failed');
                        }
                      } catch (error) {
                        verifyBtn.textContent = "Verify Integration";
                        verifyBtn.disabled = false;
                        toast.error(error?.response?.data?.message || 'Backend verification failed');
                      }
                    }
                  }}
                  startIcon={<AiOutlineCheck />}
                  sx={{ ml: 2 }}
                  className="glass-button-secondary-50"
                  ref={verifyBtnRef}
                />
              )}
            </div>
          </div>

          {/* Integration Modal */}
          <Dialog
            open={integrationModalOpen}
            onClose={() => {
              setIntegrationModalOpen(false);
              setTouched(false);
              setShowScript(false);
            }}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Integrate Website Tracking</DialogTitle>

            <DialogContent>
              <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Website Domain"
                  placeholder="example.com"
                  value={domain}
                  onChange={(e) => {
                    const raw = e.target.value.trim().replace(/^https?:\/\//, '').replace(/\/$/, '');
                    setDomain(raw);
                    setIsValidDomain(isValidDomainFormat(raw));
                    setTouched(true);
                    setShowScript(false);
                  }}
                  helperText={!isValidDomain && domain ? 'Enter a valid domain like "example.com"' : ''}
                  error={touched && !isValidDomain}
                  size="medium"
                  className="glass-input"
                />
                <Button
                  variant="contained"
                  size="medium"
                  disabled={!isValidDomain}
                  sx={{ minWidth: 120, mt: '5px !important' }}
                  onClick={async () => {
                    if (!domain || domain.trim() === '') {
                      toast.error('Please enter a valid domain');
                      return;
                    }

                    const getScriptBtn = document.activeElement;
                    getScriptBtn.textContent = "Adding...";
                    getScriptBtn.disabled = true;

                    try {
                      const response = await addDomain(organizationId, domain.trim());
                      setIsDomainIntegrated(true);
                      setShowScript(true);
                      const domains = await getDomains(organizationId);
                      setUserDomains(domains.data);
                      if(response.status === "ok"){
                        toast.success(response.message);
                      }else{
                        toast.error(response.message);
                      }

                    } catch (error) {
                      console.error('Error adding domain:', error);
                      toast.error(error.response.data.message || 'An error occurred. Please try again.');
                    } finally {
                      getScriptBtn.textContent = "Get Script";
                      getScriptBtn.disabled = false;
                    }
                  }}
                >
                  Verify
                </Button>
              </Stack>

              {domain && showScript && (
                <>
                  <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
                    Installation Instructions
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    Copy the following script and add it to your website's HTML just before the closing &lt;/head&gt; tag:
                  </Typography>

                  <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
                    <InputLabel id="platform-select-label">Select Your Platform</InputLabel>
                    <Select
                      labelId="platform-select-label"
                      id="platform-select"
                      label="Select Your Platform"
                      defaultValue="wordpress"
                      onChange={(e) => setSelectedPlatform(e.target.value)}
                      value={selectedPlatform}
                      className="glass-dropdown"
                    >
                      <MenuItem value="wordpress">WordPress</MenuItem>
                      <MenuItem value="webflow">Webflow</MenuItem>
                      <MenuItem value="shopify">Shopify</MenuItem>
                      <MenuItem value="wix">Wix</MenuItem>
                      <MenuItem value="squarespace">Squarespace</MenuItem>
                      <MenuItem value="other">Other Platforms</MenuItem>
                    </Select>
                  </FormControl>

                  {selectedPlatform === "wordpress" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.primary.main}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        WordPress Installation
                      </Typography>
                      <Stack spacing={1}>
                        <Typography variant="body2">
                          <strong>Option 1:</strong> Using a plugin
                        </Typography>
                        <ol style={{ margin: 0, paddingLeft: '20px' }}>
                          <li>Install and activate the "Insert Headers and Footers" plugin</li>
                          <li>Go to Settings → Insert Headers and Footers</li>
                          <li>Paste the tracking code into the "Scripts in Header" section</li>
                          <li>Click "Save"</li>
                        </ol>

                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Option 2:</strong> Editing theme files
                        </Typography>
                        <ol style={{ margin: 0, paddingLeft: '20px' }}>
                          <li>Go to Appearance → Theme Editor</li>
                          <li>Select your theme's header.php file</li>
                          <li>Paste the code just before the <code>&lt;/head&gt;</code> tag</li>
                          <li>Click "Update File"</li>
                        </ol>
                      </Stack>
                    </Card>
                  )}

                  {selectedPlatform === "webflow" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.info.main}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Webflow Installation
                      </Typography>
                      <ol style={{ margin: 0, paddingLeft: '20px' }}>
                        <li>Open your Webflow project</li>
                        <li>Navigate to Project Settings → Custom Code</li>
                        <li>Paste the tracking code in the "Head Code" section</li>
                        <li>Click "Save Changes"</li>
                        <li>Publish your site for changes to take effect</li>
                      </ol>
                    </Card>
                  )}

                  {selectedPlatform === "shopify" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.success.main}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Shopify Installation
                      </Typography>
                      <ol style={{ margin: 0, paddingLeft: '20px' }}>
                        <li>Log in to your Shopify admin panel</li>
                        <li>Go to Online Store → Themes</li>
                        <li>Find your current theme and click "Actions" → "Edit code"</li>
                        <li>Open the theme.liquid file (under Layout)</li>
                        <li>Locate the <code>&lt;/head&gt;</code> tag and paste the code just before it</li>
                        <li>Click "Save"</li>
                      </ol>
                    </Card>
                  )}

                  {selectedPlatform === "wix" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.warning.main}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Wix Installation
                      </Typography>
                      <ol style={{ margin: 0, paddingLeft: '20px' }}>
                        <li>Log in to your Wix account and open your site</li>
                        <li>Click on Settings (gear icon) in the dashboard</li>
                        <li>Select "Advanced" → "Custom Code"</li>
                        <li>Click "+ Add Custom Code"</li>
                        <li>Paste the tracking code</li>
                        <li>Set "Add Code to Pages" to "All pages"</li>
                        <li>Set "Place Code in" to "Head"</li>
                        <li>Click "Apply" and publish your site</li>
                      </ol>
                    </Card>
                  )}

                  {selectedPlatform === "squarespace" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.secondary.main}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Squarespace Installation
                      </Typography>
                      <ol style={{ margin: 0, paddingLeft: '20px' }}>
                        <li>Log in to your Squarespace account</li>
                        <li>Go to Settings → Advanced → Code Injection</li>
                        <li>Paste the tracking code into the "Header" field</li>
                        <li>Click "Save"</li>
                        <li>Your changes will be applied automatically</li>
                      </ol>
                    </Card>
                  )}

                  {selectedPlatform === "other" && (
                    <Card sx={{ mb: 2, p: 2, borderLeft: `4px solid ${theme.palette.grey[500]}` }} className="glass-wrapper-50">
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Other Platforms
                      </Typography>
                      <Typography variant="body2">
                        For custom websites or other platforms, add the tracking script to your HTML template files just before the <code>&lt;/head&gt;</code> tag.
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        If you're using a CMS or website builder not listed above, look for options like:
                      </Typography>
                      <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                        <li>Header scripts</li>
                        <li>Custom HTML</li>
                        <li>Code injection</li>
                        <li>Site-wide code</li>
                      </ul>
                    </Card>
                  )}

                  <Card sx={{
                    p: 2,
                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.03)',
                    position: 'relative',
                    borderRadius: '8px'

                  }}
                    className="glass-pane"
                  >
                    <pre style={{
                      overflow: 'auto',
                      margin: 0,
                      padding: '10px',
                      color: theme.palette.text.primary,
                      fontFamily: 'monospace',
                      fontSize: '13px'
                    }}>
                      {`<script async src="https://cdn.jsdelivr.net/gh/leadinglydevelopment/pixel-tracking@latest/pixel.js" data-site-id="${domain.trim()}" data-user-id="${organizationId}"></script>`}
                    </pre>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={copyToClipboard}
                      startIcon={<BsCodeSlash />}
                      sx={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        fontSize: '0.7rem',
                        padding: '4px 8px'
                      }}
                    >
                      Copy
                    </Button>
                  </Card>

                  <Typography variant="body2" sx={{ mt: 2 }}>
                    After adding the script, click "Done" and use the Verify Integration button to confirm it's working correctly.
                  </Typography>
                </>
              )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
              <Button className="glass-button-secondary-50" onClick={() => { setIntegrationModalOpen(false); setTouched(false); }}>Cancel</Button>
              <Button
                variant="contained"
                onClick={handleIntegration}
                disabled={!domain}
                sx={{ textTransform: 'none' }}
              >
                Done
              </Button>
            </DialogActions>
          </Dialog>

        </CardContent>
      </Card>

    </Stack>


  );
};

export default IntegrationSettings;
